/**
 * Numeric thresholds for the learning journey.
 *
 * Centralized so the FSM, the runtime and the views share one source of
 * truth, and so a value can be retuned in one place.
 *
 * ## What is not here any more
 *
 * Everything that graded a run in time. `RHYTHM_RUN_TOLERATED_ERRORS`,
 * `OUT_OF_WINDOW_THRESHOLD_BEAT_FRACTION`,
 * `RHYTHM_DEVIATION_TOLERANCE_EIGHTH_FRACTION`, `BURST_ERROR_COUNT`,
 * `BURST_WINDOW_BEATS`, `MIN_PHRASE_MEASURES_FOR_BURST` and
 * `S4_MODE_FALLBACK_FAILURE_COUNT` tuned a gate that, replayed over 10 528
 * real work units, failed a clean player 15.0% of the time and passed a
 * player with no rhythm at all 62.2% of the time. Retuning it was never going
 * to fix it — see `components/learn-piece/rhythm.ts`.
 *
 * `TEMPO_S4_FRACTION` is gone too, as an execution constant: what S4 plays at
 * is now computed from the unit's own density and moved by the player. What
 * remains under a new name is the rate at which the *no-rhythm* steps sound a
 * fragment as a model, which is a different decision that happened to share
 * the number.
 *
 * And `SPEEDUP_TIERS` / `SPEEDUP_FAILURES_BEFORE_SUGGEST_LOWER` went with
 * phase 2's three fixed tiers. **70.3% of units (7 406 / 10 530) open below
 * 0.75**, so the lowest tier stood above where phase 1 leaves almost
 * everyone, and the real climb is nine rungs of `RATE_LADDER`, not two. The
 * piece now carries a tempo of its own — see `components/learn-piece/piece.ts`.
 */

/**
 * Rate at which S1b / S2b / S3 sound a fragment when the player asks to hear
 * it ("▶ Écouter ce passage").
 *
 * A model, not a performance: slow enough that a beginner can follow which
 * key sounds when, fast enough that the fragment still reads as music. It is
 * not the tempo the player will be asked to play at — that one belongs to the
 * unit, not to a constant.
 */
export const AUDITION_TEMPO_FRACTION = 0.6;

/** Window used to group simultaneous presses (chord = one group). */
export const SIMULTANEOUS_GROUPING_WINDOW_MS = 30;
